// Keep in sync with apps/api/routes/merchandising/models.py WIDGET_TYPES
// and the CHECK constraint on widget.widget_type (migrations 49 and 57).

export const WIDGET_TYPES = [
  { code: 'video_embed', label: 'Video Embed' },
  { code: 'editorial', label: 'Editorial' },
  { code: 'banner_image', label: 'Banner Image' },
] as const

export type WidgetTypeCode = typeof WIDGET_TYPES[number]['code']

export const getWidgetTypeLabel = (code: string): string => {
  const found = WIDGET_TYPES.find(wt => wt.code === code)
  return found ? found.label : code
}
